// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__l5H4u"};